import { ThemeService } from "../../services/theme/ThemeService.service";

const Footer = () => {
	return (
		<footer className="footer">
			<hr className="footer__separator" />
			<div className="footer__logo">
				<img
					alt={ThemeService.setIconAlt()}
					src={ThemeService.setLogo()}
				/>
			</div>
		</footer>
	);
};
export default Footer;
